export function BrandMark({ className = "h-[25px] w-auto block flex-none" }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="ResinSmart"
    >
      <path d="M23.8859 0.00671387H20.0623V22.3277H23.8859V0.00671387Z" fill="#80ED3F" />
      <path
        d="M20.0629 7.40308L21.4592 12.2081L15.9744 20.6009C15.2297 21.7467 13.9624 22.4341 12.5876 22.4341H6.90233V18.6101H12.5876L20.0629 7.40308Z"
        fill="#80ED3F"
      />
      <path d="M3.82359 0.113525H0V22.4346H3.82359V0.113525Z" fill="#80ED3F" />
      <path
        d="M3.82388 15.0311L2.42763 10.226L7.91241 1.83323C8.65708 0.687462 9.92445 0 11.2992 0H16.9845V3.82401H11.2992L3.82388 15.0311Z"
        fill="#80ED3F"
      />
    </svg>
  );
}
